import React from "react";
import "./PhoneMockup.css";

/**
 * Reusable CSS-only phone mockup frame.
 * Props:
 *   screenshot – image src
 *   alt        – alt text (default "App screenshot")
 *   size       – "sm" | "md" | "lg" | "xl"  (default "md")
 *   className  – extra class on the outer wrapper
 *   glow       – true adds a purple ambient glow behind the phone
 */
const PhoneMockup = ({
  screenshot,
  alt = "App screenshot",
  size = "md",
  className = "",
  glow = false,
}) => {
  return (
    <div className={`pm-outer ${className}`}>
      {glow && <div className="pm-glow"></div>}
      <div className={`pm-frame pm-${size}`}>
        {/* Side buttons */}
        <div className="pm-btn pm-vol-up"></div>
        <div className="pm-btn pm-vol-dn"></div>
        <div className="pm-btn pm-power"></div>

        {/* Screen */}
        <div className="pm-screen">
          {/* Dynamic Island */}
          <div className="pm-island"></div>
          {/* App screenshot */}
          <img src={screenshot} alt={alt} className="pm-screenshot" />
          {/* Home indicator */}
          <div className="pm-home-bar"></div>
        </div>
      </div>
    </div>
  );
};

export default PhoneMockup;
